import { createAction } from 'redux-actions'

export const createNote = createAction('CREATE_NOTE')
export const createNoteSuccess = createAction('CREATE_NOTE_SUCCESS')
export const resetCreatedNoteId = createAction('RESET_CREATED_NOTE_ID')
export const createNoteError = createAction('CREATE_NOTE_ERROR')
export const selectNote = createAction('SELECT_NOTE')
export const updateNote = createAction('UPDATE_NOTE')
export const updateNoteSuccess = createAction('UPDATE_NOTE_SUCCESS')
export const updateNoteError = createAction('UPDATE_NOTE_ERROR')
export const deleteNote = createAction('DELETE_NOTE')
export const deleteNoteSuccess = createAction('DELETE_NOTE_SUCCESS')
export const deleteNoteError = createAction('DELETE_NOTE_ERROR')
export const resetDeletedNoteId = createAction('RESET_DELETED_NOTE_ID')



// WEBPACK FOOTER //
// ./src/services/note/actions.js